import { Quaternion } from "three"
import { Y_AXIS_VECTOR } from "../consts"

export function quaternionFromYRotation(radians: number): Quaternion {
  return new Quaternion().setFromAxisAngle(Y_AXIS_VECTOR, radians)
}
